import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserGuard } from './services/user.guard';
import { AdminGuard } from './services/admin.guard';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  {
    path: 'dashboard',
    canActivate: [UserGuard],
    loadChildren: () => import('./pages/dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
  {
    path: 'returnUrl',
    loadChildren: () =>
      import('./pages/subscription-succeed/subscription-succeed.module').then((m) => m.SubscriptionSucceedModule),
  },
  {
    path: 'admin-dashboard',
    canActivate: [AdminGuard],
    loadChildren: () => import('./pages/admin-dashboard/admin-dashboard.module').then((m) => m.AdminDashboardModule),
  },
  {
    path: '',
    loadChildren: () => import('./pages/landing/landing.module').then((m) => m.LandingModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
